import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';

import LoadingScreen from '../../../Ui/LoadingScreen/LoadingScreen';

import classes from './ProcessOptimizationServices.module.css';
import { pushToError } from '../../../../utils/common';
class ProcessOptimizationServices extends Component {
  state = {
    htmlApiLoading: true,
  };
  componentDidMount() {
    this.props.setCurrentRouteState('tp/services', 'Process Optimization');
    $('.' + classes.ProcessOptimizationServices).load(
      '/html/angularContainer.html',
      () => {
        const url =
          'https://dls-dev.siemens.cloud/tp/tp.static/html/tp_services.html';
        axios
          .get(url, {
            headers: { Authorization: `Bearer ${this.props.settings.token}` },
          })
          .then((response) => {
            $('#angularContainer').load(window.makeTextFile(response.data));
            this.setState({
              htmlApiLoading: false,
            });
          })
          .catch((err) => {
            console.error(err);
            pushToError(this.props,this.state.pname,err,url);
          });
      }
    );
  }
  render() {
    return (
      <React.Fragment>
        {this.state.htmlApiLoading ? <LoadingScreen /> : null}
        <div className={classes.ProcessOptimizationServices}></div>
      </React.Fragment>
    );
  }
}

export default ProcessOptimizationServices;
